import { template } from '../../utils/utils';

export interface INavItem {
  name: string;
  active?: boolean;
  href?: string;
  id: string;
}

export const SIZES = [5, 10, 20, 30, 40];

export const PAGINATION_BTNS = {
  prev: 'previous',
  next: 'next',
  start: 'start',
};

export const DEFAULT_PAGE_NO = 1;

export const DEFAULT_LIMIT = 10;

export const LIBRARY_TYPES: INavItem[] = [
  {
    name: 'My Company Questions',
    id: 'PRI',
  },
  {
    name: 'DoSelect Questions',
    id: 'MAR',
  },
];

export const INTERVIEW_PROBLEM_LIBRARY_API_HTTP_STATUS_CODES = [
  400, 401, 403, 404, 422, 500, 502, 503, 504,
];

export const INTERVIEW_PROBLEM_LIBRARY_ERROR_MESSAGE =
  'Error in fetching problem library, please try again.';

export const INTERVIEW_PROBLEM_LIBRARY_UNEXPECTED_STATUS_ERROR_MESSAGE = template`Error in fetching problem library, received status ${'status'}.`;
